import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=124eb2ac&"
import script from "./RichTextEditor.vue?vue&type=script&lang=js&"
export * from "./RichTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=124eb2ac&lang=scss&"
import style1 from "./RichTextEditor.vue?vue&type=style&index=1&id=124eb2ac&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124eb2ac')) {
      api.createRecord('124eb2ac', component.options)
    } else {
      api.reload('124eb2ac', component.options)
    }
    module.hot.accept("./RichTextEditor.vue?vue&type=template&id=124eb2ac&", function () {
      api.rerender('124eb2ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/popup/RichTextEditor.vue"
export default component.exports